// extracted by mini-css-extract-plugin
module.exports = {"svgButton":"Star_svgButton__lj9zk"};